import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBudgetPublishPreview, updateBudgetPublishStatus } from '../../slices/quickbooks/budgetSlice';
import { toast } from 'react-toastify';

export const BudgetPublishModal = ({ budgetId, isOpen, onClose, onSuccess, unpublish = false }) => {
    const dispatch = useDispatch();
    const preview = useSelector((state) => state.budget.budgetPublishPreview);
    useEffect(() => {
        if (isOpen && !unpublish && budgetId) dispatch(getBudgetPublishPreview(budgetId));
    }, [isOpen, unpublish, budgetId, dispatch]);
    if (!isOpen) return null;
    const confirm = async () => {
        try {
            await dispatch(updateBudgetPublishStatus({ id: budgetId, publishStatus: unpublish ? 'DRAFT' : 'PUBLISHED' })).unwrap();
            toast.success(unpublish ? 'Budget unpublished.' : 'Budget published.');
            await onSuccess?.();
            onClose();
        } catch (error) {
            toast.error(error?.error || 'Failed to update Budget publication');
        }
    };
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-4">
            <div className="w-full max-w-lg rounded-lg bg-white p-5 shadow-xl">
                <h2 className="text-lg font-semibold">{unpublish ? 'Unpublish Budget' : 'Publish Budget'}</h2>
                {!unpublish && (
                    <>
                        <div className="mt-3 text-sm text-gray-700">Source: {preview?.state?.source?.plan?.name || (preview?.state?.source?.legacy ? 'Legacy source' : 'None')}</div>
                        {(preview?.warnings || []).length > 0 && <ul className="my-3 list-disc pl-5 text-sm text-amber-700">{preview.warnings.map((warning) => <li key={warning}>{warning.replaceAll('_', ' ')}</li>)}</ul>}
                        <p className="text-sm text-gray-700">Daily Budget will be activated for: {(preview?.months_to_activate || []).join(', ') || 'none'}</p>
                        <p className="mt-2 text-sm text-gray-700">Frozen (unchanged): {(preview?.months_frozen || []).join(', ') || 'none'}</p>
                        {(preview?.demoted_budgets || []).length > 0 && <p className="mt-2 text-sm text-gray-700">These Budgets will be set to Draft: {preview.demoted_budgets.map((budget) => budget.name).join(', ')}</p>}
                    </>
                )}
                <div className="mt-5 flex justify-end gap-2">
                    <button type="button" onClick={onClose} className="rounded border px-3 py-2 text-sm">Cancel</button>
                    <button type="button" onClick={confirm} className="rounded bg-blue-600 px-3 py-2 text-sm font-medium text-white">{unpublish ? 'Unpublish' : 'Publish Budget'}</button>
                </div>
            </div>
        </div>
    );
};
